import Vue from "vue";
import { plugin } from "vue-function-api";

Vue.use(plugin);
